// extracted by mini-css-extract-plugin
var _1 = "ActionsPopup_icon__8LmFd";
export { _1 as "icon" }
